import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchOffersUpdatePreview = async (body) => {
  const response = await axiosInstance.post('/offers/update/preview/', body);
  return response.data;
};

/**
 * Résumé d'impact d'une mise à jour d'offres, sans effet de bord côté
 * marketplace. C'est un POST parce que le payload (jusqu'à 5000 ids) ne tient
 * pas dans une query string, mais sémantiquement une lecture : d'où le
 * useQuery, qui recalcule tout seul quand la cible ou le scope change.
 */
export const usePreviewOffersUpdate = (body, options = {}) => {
  const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['mpOffersUpdatePreview', body],
    queryFn: () => fetchOffersUpdatePreview(body),
    enabled: options.enabled ?? true,
    staleTime: 30 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return {
    preview: data,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
